<template>
  <div class="login_container">
    <div class="login_box">
      <div class="avatar_box">
        <!-- 头像区域 -->
        <img src="@/assets/logo.png"
             alt />
      </div>

      <!-- 表单区域 -->
      <el-form ref="loginFormRef"
               :rules="rules"
               :model="loginForm"
               label-width="0px"
               class="login_form">
        <!-- <el-form-item prop="ptnCode">
          <el-select v-model="loginForm.ptnCode"
                     placeholder="请选择商家"
                     style="width:100%">
            <el-option v-for="item in PartnerLists"
                       :key="item.id"
                       :label="item.ptnName"
                       :value="item.ptnCode"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item prop="username">
          <el-input v-model="loginForm.username"
                    size="medium"
                    placeholder="请输入用户名"
                    prefix-icon="el-icon-user-solid"></el-input>
        </el-form-item>

        <!-- 密码-->
        <el-form-item prop="password">
          <el-input v-model="loginForm.password"
                    @keyup.enter.native="login"
                    placeholder="请输入密码"
                    type="password"
                    size="medium"
                    prefix-icon="el-icon-key"></el-input>
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item class="btns">
          <el-button type="primary"
                     :loading="loginLoading"
                     @click="login">登陆</el-button>
          <el-button type="info"
                     @click="resetLoginFrom">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      PartnerLists: [],
      loginLoading: false,
      // 登陆表单数据绑定
      loginForm: {
        username: '',
        password: '',
      },
      rules: {
        ptnCode: [{ required: true, message: '请选择商家', trigger: 'change' }],
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          {
            min: 2,
            max: 32,
            message: '长度在 2 到 32 个字符',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 3,
            max: 20,
            message: '长度在 3 到 20 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    // this.getPartnerLists()
  },
  methods: {
    // 点击重置按钮
    resetLoginFrom() {
      this.$refs.loginFormRef.resetFields()
    },

    // 点击登陆 登陆前验证
    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.loginLoading === true) {
          return
        }
        this.loginLoading = true

        await this.$http
          .post('login', this.loginForm)
          .then((response) => {
            // this.$message.success({
            //   message: '登陆成功',
            //   offset: 61,
            // })

            const res = response.data
            // 保存token到sessionStorage中
            window.sessionStorage.setItem('token', res.data.token)
            // 保存用户
            window.sessionStorage.setItem('username', res.data.username)
            // 保存商家信息
            window.sessionStorage.setItem('ptnCode', res.data.ptnCode)
            window.sessionStorage.setItem('email', res.data.email)

            window.sessionStorage.setItem('mobile', res.data.mobile)

            window.sessionStorage.setItem('id', res.data.id)
            window.sessionStorage.setItem('loginSts', 1)
            this.loginLoading = false

            // 跳转到主页
            this.$router.push('/welcome')
          })
          .catch((error) => {
            this.loginLoading = false
            return this.$message.error(error.response.data.message)
          })
      })
    },
    // 获取商家列表
    async getPartnerLists() {
      await this.$http
        .post('ptnlists', {
          query: '',
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data

          this.PartnerLists = res.data.data
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
  },
}
</script>

<style lang='less' scoped>
.login_container {
  background-color: #317bdd;
  height: 100%;
}
.login_box {
  height: 350px;
  width: 450px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.avatar_box {
  height: 130px;
  width: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}
.btns {
  display: flex;
  justify-content: flex-end;
}
.login_form {
  position: absolute;
  font-size: 150%;
  bottom: 20px;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
}
/deep/.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 30px;
}
/deep/.el-input--medium {
  font-size: 18px;
}
/deep/.el-input--prefix .el-input__inner {
  padding-left: 39px;
}
/deep/.el-input--medium .el-input__inner {
  height: 42px;
  line-height: 42px;
}
/deep/.el-input--medium .el-input__icon {
  line-height: 42px;
}
/deep/.el-form-item__error {
  font-size: 16px;
}
/deep/.el-button--mini,
.el-button--small {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/Login.vue